import { render, staticRenderFns } from "./OS.vue?vue&type=template&id=67c55f26&scoped=true"
import script from "./os.js?vue&type=script&lang=js&external"
export * from "./os.js?vue&type=script&lang=js&external"
import style0 from "./os.scss?vue&type=style&index=0&id=67c55f26&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c55f26",
  null
  
)

export default component.exports